import { render, staticRenderFns } from "./chatRoom.vue?vue&type=template&id=4b5b54a3&scoped=true"
import script from "./chatRoom.vue?vue&type=script&lang=js"
export * from "./chatRoom.vue?vue&type=script&lang=js"
import style0 from "./chatRoom.vue?vue&type=style&index=0&id=4b5b54a3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b5b54a3",
  null
  
)

export default component.exports